// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"Sort_modalBackdrop__7427c","modal":"Sort_modal__0IZNp","subtitle":"Sort_subtitle__Hee2O","loadingRoot":"Sort_loadingRoot__fekOH"};